export class Untyped {
    options;
    constructor(options = {}) {
        this.options = options;
    }
    parse(data) {
        let result;
        try {
            result = JSON.parse(data);
        }
        catch {
            result = undefined;
        }
        return result;
    }
    stringify(data) {
        return JSON.stringify(data, this.options?.replacer, this.options?.space);
    }
}
//# sourceMappingURL=Untyped.js.map